import { useEffect, useState } from "react";
import {
    AccountPrivateGatewayNumberStatusDto,
    GatewayNumberDto,
    SmsCampaignDto,
    SmsCampaignDtoListResult,
} from "../../../api/psc";
import { SmsCampaignService } from "../../../api/psc/services/SmsCampaignService";
import useFetchQuery from "../../../hooks/useFetchQuery";

const fetchSmsListFunction = async (offset: number) =>
    SmsCampaignService.listSmsCampaigns("1", offset);

export const useFetchSmsListQuery = () => {
    const [moreData, setMoreData] = useState<SmsCampaignDto[]>([]);
    const [hasMore, setHasMore] = useState(false);

    const { data, error, isLoading, firstTimeLoading, reFetch } =
        useFetchQuery<SmsCampaignDtoListResult>(fetchSmsListFunction);

    const fetchMore = async () => {
        const result = await fetchSmsListFunction(data.results.length);

        setMoreData((prevData) => [...prevData, ...result.results]);
    };

    //The [...data.results, ...moreData] array is the all data we have got from data
    //This type of data has a count property which is the total number of data
    //This condition checks if we got all the data from server or not
    useEffect(() => {
        if (data && [...data.results, ...moreData].length < data.count) {
            setHasMore(true);
        } else {
            setHasMore(false);
        }
    }, [data, moreData]);

    return {
        data: data && [...data.results, ...moreData],
        count: data && data.count,
        isLoading,
        error,
        firstTimeLoading,
        reFetch,
        fetchMore,
        hasMore,
    };
};
export type FetchSmsListQueryType = ReturnType<typeof useFetchSmsListQuery>;

const fetchSmsCampaignGatewayNumbersFunction = async () =>
    SmsCampaignService.listGatewayNumbers("1");
export const useFetchGatewaNumbersQuery = () =>
    useFetchQuery<GatewayNumberDto[]>(fetchSmsCampaignGatewayNumbersFunction);
export type FetchSmsCampaignGatewayNumbersRequirementsType = ReturnType<
    typeof useFetchGatewaNumbersQuery
>;

const fetchPrivateGateWayNumberFunction = async () =>
    SmsCampaignService.getPrivateGatewayNumbersStatus("1");
export const useFetchPrivateGateWayNumberQuery = () =>
    useFetchQuery<AccountPrivateGatewayNumberStatusDto>(
        fetchPrivateGateWayNumberFunction
    );
export type FetchPrivateGateWayNumberType = ReturnType<
    typeof useFetchGatewaNumbersQuery
>;
